<template>
  <div>
    <el-row>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header"></i>
          <span>性能概况</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="el-card-small">
              <el-row>
                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_1.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.total_cnt*0.9' :endVal='record.total_cnt'
                             :duration='changeSlow'></CountTo>
                  </el-row>
                  <el-row :span="24" class="hintClass">全部数据量</el-row>
                </el-col>

                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_2.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.this_month_cnt*0.9' :endVal='record.this_month_cnt'
                             :duration='changeSlow'></CountTo>
                  </el-row>
                  <el-row :span="24" class="hintClass">当月数据量</el-row>
                </el-col>

              </el-row>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="el-card-small">
              <el-row>
                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_3.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.index_size*0.9' :endVal='record.index_size'
                             :duration='changeSlow'></CountTo>
                    （GB）
                  </el-row>
                  <el-row :span="24" class="hintClass">存储空间</el-row>
                </el-col>

                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_4.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.search_time*0.9' :endVal='record.search_time'
                             :duration='changeSlow'></CountTo>
                    （毫秒）
                  </el-row>
                  <el-row :span="24" class="hintClass">检索平均耗时</el-row>
                </el-col>

              </el-row>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="el-card-small">
              <el-row>
                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_5.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.parall_user*0.9' :endVal='record.parall_user'
                             :duration='changeSlow'></CountTo>
                  </el-row>
                  <el-row :span="24" class="hintClass">并发用户</el-row>
                </el-col>

                <el-col :span="3" class="numClass" style="color:green">
                  <img src="../assets/admin/info_6.png" height="50px" width="50px"/>
                </el-col>
                <el-col :span="9">
                  <el-row class="numClass" style=" color: #17DEFF;">
                    <CountTo :startVal='record.parall_time*0.9' :endVal='record.parall_time'
                             :duration='changeSlow'></CountTo>
                    （毫秒）
                  </el-row>
                  <el-row :span="24" class="hintClass">请求耗时</el-row>
                </el-col>

              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header"></i>
          <span>性能监测</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <Gauge id="c1" path="perf_info" :key="perf_data" :params='{"slot":"cpu_percent","slot_human":"CPU利用率"}' height="300px" width="100%"></Gauge>
          </el-col>
          <el-col :span="12">
            <Gauge id="c2" path="perf_info" :key="perf_data" :params='{"slot":"mem_percent","slot_human":"内存利用率"}' height="300px" width="100%"></Gauge>
          </el-col>
          <el-col :span="12" style="margin-top: 20px">
            <Gauge id="c3" path="perf_info" :key="perf_data" :params='{"slot":"gpu_load","slot_human":"GPU利用率"}' height="300px" width="100%"></Gauge>
          </el-col>
          <el-col :span="12" style="margin-top: 20px">
            <Gauge id="c4" path="perf_info" :key="perf_data" :params='{"slot":"gpu_mem_usage","slot_human":"GPU显存利用率"}' height="300px" width="100%"></Gauge>
          </el-col>
        </el-row>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import CountTo from 'vue-count-to';
import Gauge from "@/views/charts/gauge";

export default {
  name: "DataPerf",
  components: {
    CountTo,
    Gauge,
  },
  created () {
    this.get_perf();
    this.timer = setInterval(this.get_perf, 30000);
  },
  data() {
    return {
      changeSlow: 2000,
      record: {
        total_cnt: 222785204,
        this_month_cnt: 969653,
        index_size: 24.7,
        search_time: 12,
        parall_user: 243,
        parall_time: 32.1,
      },
      perf_data:null,
      timer: ''
    }
  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  },
  methods: {
    get_perf() {
        this.perf_data = Math.random()
    },
    cancelAutoUpdate () {
      clearInterval(this.timer);
    }
  }
}
</script>

<style scoped>


.el-card /deep/ .el-card__header {
  border-bottom: none;
  /* height: 40px; */
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}


.el-card-small {
  border: 0px solid #EBEEF5;
}

.el-card-small /deep/ .el-card__header {
  border-bottom: none;

  height: 40px;
  padding: 10px 20px;
}

.el-card-small /deep/ .el-card__body {
  background-color: #42444F;
}
</style>

